import { javascript } from '@codemirror/lang-javascript';
import { json, jsonParseLinter } from '@codemirror/lang-json';
import { markdown } from '@codemirror/lang-markdown';
import { StreamLanguage } from '@codemirror/language';
import { yaml } from '@codemirror/legacy-modes/mode/yaml';
import { linter } from '@codemirror/lint';

import type { EditorLanguageConfiguration } from '../../base-code-editor/configuration/configuration.js';
import { javascriptAutocompleteProvider } from '../auto-completion/javascript.js';

/**
 * @internal
 */
export const codeEditorLanguages = {
  other: {
    extendWith: [],
  } as EditorLanguageConfiguration,
  json: {
    language: json().language,
    extendWith: [linter(jsonParseLinter())],
  } as EditorLanguageConfiguration,
  js: {
    language: javascript().language,
    extendWith: [],
    autocompleteOptions: {
      activateOnTyping: true,
      providers: [javascriptAutocompleteProvider],
    },
  } as EditorLanguageConfiguration,
  jsx: {
    language: javascript({ jsx: true }).language,
    extendWith: [],
    autocompleteOptions: {
      activateOnTyping: true,
      providers: [javascriptAutocompleteProvider],
    },
  } as EditorLanguageConfiguration,
  ts: {
    language: javascript({ typescript: true }).language,
    extendWith: [],
    autocompleteOptions: {
      activateOnTyping: true,
      providers: [javascriptAutocompleteProvider],
    },
  } as EditorLanguageConfiguration,
  tsx: {
    language: javascript({ typescript: true, jsx: true }).language,
    extendWith: [],
    autocompleteOptions: {
      activateOnTyping: true,
      providers: [javascriptAutocompleteProvider],
    },
  } as EditorLanguageConfiguration,
  md: {
    language: markdown().language,
    extendWith: [],
  } as EditorLanguageConfiguration,
  yaml: {
    language: StreamLanguage.define(yaml),
    extendWith: [],
  } as EditorLanguageConfiguration,
} as const;

export type CodeEditorLanguages = keyof typeof codeEditorLanguages;

/** All possible languages as array */
export const CodeEditorLanguageKeys = Object.keys(
  codeEditorLanguages,
) as CodeEditorLanguages[];
